import i18next from 'i18next';
import { toast } from 'react-toastify';

class ErrorHelper {
  handleGenericError = () => {
    toast.error(i18next.t('ERROR.GENERIC'));
  };

  handleUnknownError = () => {
    toast.error(i18next.t('ERROR.UNKNOWN'));
  };
}

export default new ErrorHelper();
